<template>
  <div id="div_drawer" @mouseover="mouseOver" @mouseleave="mouseLeave">
    <v-navigation-drawer
      :floating="true"
      v-model="drawer"
      v-bind="$props"
      :class="drawerClass"
    >
      <v-container pa-0>
        <v-row>
          <v-col class="py-0">
            <component :is="component" />
          </v-col>
        </v-row>
      </v-container>
      <template v-if="name === 'mainMenu'" #prepend />
    </v-navigation-drawer>
  </div>
</template>

<script>
import { AccountMenu } from '@dinamonetworks/gui-comps-lib'
import LanguageRadioGroup from '@/components/LanguageRadioGroup'
export default {
  components: {
    AccountMenu,
    LanguageRadioGroup
  },
  props: {
    id: {
      type: String,
      required: false,
      default: 'navigation_drawer'
    },
    name: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      default: 310
    },
    height: {
      type: String || Number,
      default: '100%'
    },
    app: {
      type: Boolean,
      default: () => false
    },
    clipped: {
      type: Boolean,
      default: () => false
    },
    right: {
      type: Boolean,
      default: () => false
    },
    temporary: {
      type: Boolean,
      default: () => false
    },
    fixed: {
      type: Boolean,
      default: () => false
    },
    absolute: {
      type: Boolean,
      default: () => false
    },
    permanent: {
      type: Boolean,
      default: () => false
    },
    scroll: {
      type: Boolean,
      default: () => false
    },
    disableMainScroll: {
      type: Boolean,
      default: () => true
    },
    expandOnHover: {
      type: Boolean,
      default: () => false
    },
    miniVariant: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      component: null
    }
  },
  computed: {
    drawerClass () {
      return this.$vuetify.breakpoint.smAndDown ? 'small-display' : 'large-display'
    },
    drawer: {
      get () {
        return this.$store.state.drawers[this.name]
      },
      set (val) {
        if (!val) {
          const mutation = this.$store.getters['drawers/getMutation'](this.name)
          this.$store.commit(`drawers/${mutation}`, false)
        }
      }
    },
    loader () {
      if (!this.name) return null

      const component = this.$store.getters['drawers/getComponent'](this.name)
      return () => import(`./${component}`)
    }
  },
  methods: {
    setNoScrollbar () {
      const el = document.querySelector('html')
      el.classList.add('no-scrollbar')
    },
    removeNoScrollbar () {
      const el = document.querySelector('html')
      el.classList.remove('no-scrollbar')
    },
    doDisableMainScroll () {
      if (this.drawer === true) {
        if (this.disableMainScroll === true) {
          return this.setNoScrollbar()
        }
      } else {
        return this.removeNoScrollbar()
      }
    },
    mouseOver () {
      // console.log('over')
      // this.setNoScrollbar()
    },
    mouseLeave () {
      // console.log('leave')
      // if (this.disableMainScroll === false) {
      //   console.log('remove')
      //   this.removeNoScrollbar()
      // }
    }
  },
  mounted () {
    this.loader()
      .then(() => {
        this.component = () => this.loader()
      })
      .catch(() => {
        this.component = () => import('./AppDefaultDrawer')
      })
  },
  watch: {
    drawer (val) {
      // this.doDisableMainScroll()
    }
  }
}
</script>

<style lang="scss">
#div_drawer {
  #main_menu_drawer.theme--dark.v-navigation-drawer.small-display {
    background-color: #363636;
  }
  #main_menu_drawer.theme--dark.v-navigation-drawer.large-display {
    background-color: #121212;
  }
  .v-navigation-drawer__content {
    overflow-y: initial;
    overflow-x: initial;
  }
}
</style>
